const StencilDisplay = ({ stencilData, volunteerName }) => {
  return (
    <>
      <p className="vol-checktitle">
        <strong>Is this correct?</strong>
      </p>

      <div className="vol-pill vol-confirm">
        <div className="vol-name-row">
          <span className="vol-name">{stencilData.stencil.name}</span>
        </div>

        <div className="vol-meta-row">
          <span className="vol-meta-label">Stencil ID</span>
          <span className="vol-meta-value">{stencilData.stencil.id}</span>
        </div>

        <div className="vol-meta-row">
          <span className="vol-meta-label">Category</span>
          <span className="vol-meta-value">
            {stencilData.category === null
              ? `\u2014\u2014`
              : `${stencilData.category.name}`}
          </span>
        </div>

        {/* Volunteer name */}
        <div className="vol-meta-row">
          <span className="vol-meta-label">Your Name</span>
          <span className="vol-meta-value">{volunteerName}</span>
        </div>
      </div>
    </>
  );
};

export default StencilDisplay;
